/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useRef } from 'react'
import { KTSVG } from '../../../../helpers'
import { getCSSVariableValue } from '../../../../assets/ts/_utils'
import { useThemeMode } from '../../../layout/theme-mode/ThemeModeProvider'
import { Color, Chart } from 'chart.js'
import { config } from 'process'
import { hide } from '@popperjs/core'
import { DropdownFilterDate } from '../../../content/dropdown/DropdownFilterDate' // module "c:/Projects/VDSoftware/AISenseUs/Api/Dashboard/src/_metronic/partials/content/dropdown/Dropdown1"
import { Rating } from '../../../content/Rating'
import { LanguageHelp } from '../../../../helpers/LanguageHelper'
import { getHappinessScore, textOverflowWithEllipsis } from '../../../../helpers/utility'
var countChart = 0

export class CardsWidget18Dto { allCount = -1; competitorVolumes = [] as CardsWidget18Dto_CompetitorVolume[]; }
export class CardsWidget18Dto_CompetitorVolume { competitorName = ""; count = 0; }


type Props = {
  id: string
  className: string
  name?: string
  title?: string
  chartSize?: number
  chartLine?: number
  chartRotate?: number
  symbol?: string
  rate?: number
  data?: CardsWidget18Dto
  functionSubmit?: any
  functionDownload?: any
  isDownloadContinue?: boolean
  options?: string[]
  selectedOption?: string
  selectedDate?: string
  height?: string
  isCompetitorControl?: boolean
  isWaringImageMirror?: boolean
}

export function getColor(color: string) {
  return "#" + color;
}

const CardsWidget18: FC<Props> = ({
  id,
  className,
  chartSize = 90,
  chartLine = 11,
  chartRotate = 145,
  title = "Projects Earnings in April",
  name = "Projects Earnings in April",
  symbol = "$",
  data = new CardsWidget18Dto(),
  functionSubmit,
  functionDownload,
  isDownloadContinue = false,
  options = [],
  selectedOption = LanguageHelp('All'),
  selectedDate = LanguageHelp('Last 30 days'),
  height = "250px",
  isCompetitorControl = false,
  isWaringImageMirror = false
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  useEffect(() => {
    refreshChart()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  })

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }
    setTimeout(() => {
      initChart(id, chartSize, chartLine, chartRotate, data)
    }, 10)
  }

  return (
    <div className={`card ${className}`}>
      <div className='card-header pt-5'>
        <div className='card-title d-flex flex-column'>
          <span className='card-label fw-bold text-dark'>{title}</span>
          <div>
            <span className='text-gray-400 fw-semibold fs-6'>{name}:</span>
            {data.allCount !== -1 && data.allCount !== 0 &&
              <div style={{ display: 'unset' }}>
                <span className='fs-4 fw-semibold text-gray-400 me-1 align-self-start'>{symbol}</span>
                <span className='card-label fw-bolder text-gray-700 mt-2 pt-1'>{data.allCount}</span>
                {/* <Rating rate={data.rate} /> */}
              </div>
            }
          </div>
        </div>
        <DropdownFilterDate functionSubmit={functionSubmit} />

      </div>

      {data.allCount === -1 &&
        <div>
          <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
            <div className='d-flex flex-center me-5 pt-2'>
              <span className='indicator-progress' style={{ display: 'block', margin: 'auto' }}>
                {/* Please wait...{' '} */}
                <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
                <div
                  style={{ minWidth: chartSize + 'px', minHeight: chartSize + 'px' }}
                ></div>
              </span>
            </div>
          </div>

          <div className='card-footer pt-5 pb-5'>
            <span className='text-gray-400 fw-semibold fs-6'></span>
          </div>
        </div>
      }

      {data.allCount !== -1 &&
        <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
          <div className='d-flex flex-center me-5 pt-2'>
            <div
              id={id}
              ref={chartRef}
              style={{ minWidth: chartSize + 'px', minHeight: chartSize + 'px' }}
              data-kt-size={chartSize}
              data-kt-line={chartLine}
            ></div>
          </div>
          <div className='rows'>
            {
              data.competitorVolumes
                .map((competitorVolume: any, i: any) => {
                  return (
                    <div className='d-flex flex-column content-justify-center flex-row-fluid'
                      key={`competitorVolume-${i}-${competitorVolume.id}`}>
                      <div className='d-flex fw-semibold align-items-center'>
                        <div className='bullet w-8px h-3px rounded-2 bg-success me-3' style={{
                          backgroundColor: ['#FF9900', '#3366CC', '#DC3912', '#109618', '#990099', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395',
                            '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#329262', '#5574A6'][i]
                        }}></div>
                        <div className='text-gray-500 flex-grow-1 me-4'>{competitorVolume.competitorName === "We" ? LanguageHelp('We') : textOverflowWithEllipsis(competitorVolume.competitorName)}</div>
                        <div className='fw-bolder text-gray-700 text-xxl-end'>% {Math.round(getHappinessScore(competitorVolume.count, (data.allCount - competitorVolume.count)) * 100)}</div>
                        <div className='fw-bolder text-gray-700 text-xxl-end'> ,   {LanguageHelp('Volume')}: {competitorVolume.count}</div>
                        {/* <Rating rate={data.firstRate} /> */}

                      </div>
                    </div>
                  )
                })
            }
          </div>

        </div>

      }
    </div>
  )
}

const initChart = function (
  id: string,
  chartSize: number = 90,
  chartLine: number = 11,
  chartRotate: number = 145,
  data: CardsWidget18Dto = new CardsWidget18Dto()
) {

  const el = document.getElementById(id)
  if (!el) {
    return
  }
  if (countChart === data.allCount)
    return
  el.innerHTML = ''
  countChart = data.allCount
  var options = {
    size: chartSize,
    lineWidth: chartLine,
    rotate: chartRotate,
    data: data.competitorVolumes,
  }

  const canvas = document.createElement('canvas')
  const span = document.createElement('span')
  canvas.width = canvas.height = options.size
  // @ts-ignore
  if (typeof G_vmlCanvasManager !== 'undefined') {
    // @ts-ignore
    G_vmlCanvasManager.initElement(canvas)
  }

  const ctx = canvas.getContext('2d')

  let myChart = new Chart(canvas, {
    type: 'pie',
    data: {
      labels: data.competitorVolumes.map(a => a.competitorName),
      datasets: [{
        backgroundColor: ['#FF9900', '#3366CC', '#DC3912', '#109618', '#990099', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395',
          '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#329262', '#5574A6'],
        data: data.competitorVolumes.map(a => a.count)
      }]
    },
    options: {
      plugins: {
        legend: {
          display: false
        }
      }
    }
  });
  el.appendChild(span)
  el.appendChild(canvas)
}

export { CardsWidget18 }
